import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="section-container max-w-3xl">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mt-1">意见反馈 · 商务合作</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200 p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center mb-8">
            {contactData.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            <div className="flex flex-col items-center text-center p-4 bg-background-100 rounded-xl">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 mb-3">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">电子邮箱</span>
              <span className="text-sm font-medium text-foreground-800">{contactData.email}</span>
            </div>

            <div className="flex flex-col items-center text-center p-4 bg-background-100 rounded-xl">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mb-3">
                <i className="ri-wechat-line text-accent-500 text-lg"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">微信公众号</span>
              <span className="text-sm font-medium text-foreground-800">{contactData.wechat}</span>
            </div>

            <div className="flex flex-col items-center text-center p-4 bg-background-100 rounded-xl">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 mb-3">
                <i className="ri-weibo-line text-secondary-500 text-lg"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">官方微博</span>
              <span className="text-sm font-medium text-foreground-800">{contactData.weibo}</span>
            </div>
          </div>

          <p className="text-xs text-foreground-400 text-center mt-6">
            {contactData.workingHours}
          </p>
        </div>
      </div>
    </section>
  );
}